import { IDictionary, ReadonlyCollection } from "@ioip/core/lib";
import { IJSDataSource } from "../../types/IJSDatasource";
import { FieldValueType, IFieldValue } from "./IFieldValue";

export class JSDataSource {

    #schema: IJSDataSource;
    #items: ReadonlyCollection<IDictionary<IFieldValue>> = null;

    constructor(schema: IJSDataSource) {
        this.#schema = schema;
        this.#items = new ReadonlyCollection<IDictionary<any>>(this.#schema?.items || []);
    }

    get items(): ReadonlyCollection<IDictionary<any>> {
        return this.#items ?? new ReadonlyCollection<IDictionary<any>>([]);
    };

    get keyBinding(): string {
        return this.#schema?.keyBinding;
    };

    get textBinding(): string {
        return this.#schema?.textBinding;
    };

    get type(): string {
        return this.#schema.type;
    };

    getText(selectedKey: string | number): FieldValueType {
        const textBinding = this.textBinding;
        const keyBinding = this.keyBinding;
        const item = this.#items.firstOrDefault(x => x[ keyBinding ]?.value == selectedKey);
        return item?.[ textBinding ].value;
    }

}